<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g opacity="0.3">
            <rect x="0.2" y="0.2" width="23.6" height="23.6" rx="2.8" fill="#E6EBF0"/>
            <rect x="0.2" y="0.2" width="23.6" height="23.6" rx="2.8" fill="#C1D1E5"/>
            <rect x="0.2" y="0.2" width="23.6" height="23.6" rx="2.8" stroke="#CEDCED" stroke-width="0.4"/>
        </g>
        <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="1.8" fill="white"/>
        <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="1.8" fill="#27B8A2"/>
        <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="1.8" stroke="#CEDCED" stroke-width="0.4"/>
        <path d="M8 12.0508L11.0469 15L17 9" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>
<script>
const filledCheckInput = {
    name: 'filledCheckInput',
}
export default filledCheckInput
export { filledCheckInput }
</script>
